
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinnighole() {



const cardData = {
  keyword: 'Corporate Cab and Bus Services in Nighoje MIDC',
  heading: 'eTravo: Corporate Cab and Bus Services in Nighoje MIDC',
  headingDescription: `eTravo offers efficient and reliable corporate cab and bus services in Nighoje MIDC, one of Pune’s prominent industrial zones known for housing major automobile, engineering, and manufacturing units. Our transport solutions are designed to support companies with seamless employee commutes, executive travel, and shift-based workforce movement.`,

  top: 'Top Places to visit in Pune with eTravo',
  "topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Hinjewadi is Pune’s largest IT hub, home to major tech companies like Infosys, Wipro, TCS, and Cognizant. eTravo provides daily employee transportation, shuttle services, and executive cabs to support corporate mobility in this high-traffic zone, ensuring timely shift-based commutes."
  },
  {
    "title": "Magarpatta City SEZ",
    "description": "Magarpatta is a well-planned commercial township that houses numerous corporate offices, especially in the IT and finance sectors. eTravo offers customized transport for employees, clients, and business meetings, making daily operations more efficient and stress-free."
  },
  {
    "title": "Pune Railway Station",
    "description": "A key transit point in the city, Pune Junction connects travelers across Maharashtra and India. eTravo ensures smooth last-mile connectivity with prompt pickup and drop services for commuters, corporate travelers, and tourists alike."
  },
  {
    "title": "Shivajinagar Commercial Area",
    "description": "This central district of Pune is a hub of legal offices, banks, and government institutions. eTravo's executive cab service supports professionals commuting for legal work, government duties, and high-priority business interactions."
  },
  {
    "title": "Pimpri-Chinchwad Industrial Zone",
    "description": "One of India’s major industrial belts, Pimpri-Chinchwad houses companies like Tata Motors, Bajaj Auto, and SKF. eTravo provides reliable transport for factory workers, supervisors, and logistics teams, operating on shift schedules with precision."
  },
  {
    "title": "Kharadi IT and Business Park",
    "description": "Kharadi is a rapidly growing IT corridor with offices of multinational companies such as IBM, EON, and Barclays. eTravo's tech-enabled cab solutions cater to business travelers and daily office commutes with efficiency and safety."
  },
  {
    "title": "Swargate Bus Terminal",
    "description": "Swargate is a major road transport hub linking Pune with cities across Maharashtra. eTravo offers cab services to help passengers travel comfortably to and from Swargate, ensuring they catch their intercity buses on time."
  },
  {
    "title": "Deccan Gymkhana",
    "description": "A vibrant area with a mix of education, entertainment, and shopping. eTravo serves students, shoppers, and professionals in the area with flexible cab services suited for short rides, events, and daily commuting."
  },
  {
    "title": "Pune International Airport (Lohegaon)",
    "description": "The city’s primary air travel hub, connecting Pune with major domestic and international destinations. eTravo provides airport transfers with real-time flight tracking, professional drivers, and 24/7 support for stress-free travel experiences."
  },
  {
    "title": "Symbiosis International University (Lavale Campus)",
    "description": "A renowned academic institution in Pune attracting students from across India and abroad. eTravo ensures safe, regular, and comfortable transportation for students and faculty, particularly to remote campuses like Lavale."
  }
],

services: [
  {
    name: 'Corporate Employee Transportation Nighoje MIDC',
    description: `Reliable monthly employee transportation solutions for corporates in Nighoje MIDC. Designed to support smooth daily commutes with GPS-enabled vehicles, trained drivers, and shift-aligned scheduling.`
  },
  {
    name: 'Office Cab & Bus Hire Nighoje',
    description: `Monthly cab and bus hire services for offices in Nighoje, ideal for transporting teams across shifts and locations. Includes AC and non-AC vehicles, professional drivers, and real-time route monitoring.`
  },
  {
    name: 'Industrial Area Staff Shuttle Nighoje',
    description: `Efficient shuttle services for staff working in Nighoje Industrial Area. Operates on fixed or dynamic routes with vans or minibuses, supporting group commutes for various shift timings.`
  },
  {
    name: 'Budget-Friendly Corporate Commute Nighoje',
    description: `Affordable corporate transport packages for companies in Nighoje seeking dependable employee commute solutions. Enjoy predictable monthly costs, vehicle flexibility, and consistent service quality.`
  },
  {
    name: 'AC Cab and Bus Rentals Nighoje MIDC',
    description: `Comfort-focused AC cab and bus rental options for companies in Nighoje MIDC. Monthly plans available for staff, executives, or client transport needs with clean, well-maintained vehicles.`
  },
  {
    name: 'Business Event Transport in Nighoje',
    description: `Transport coordination services for business events, meetings, and corporate gatherings in Nighoje. Our fleet includes cabs and buses with courteous chauffeurs, ideal for large or small groups.`
  }
],

tableData: [
  ['Corporate Employee Transportation Nighoje MIDC', 'Office Cab & Bus Hire Nighoje'],
  ['Industrial Area Staff Shuttle Nighoje', 'Budget-Friendly Corporate Commute Nighoje'],
  ['AC Cab and Bus Rentals Nighoje MIDC', 'Business Event Transport in Nighoje']
],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Nighoje MIDC",
    "WhyChoosedescription": "eTravo provides dependable and efficient cab and bus transportation services tailored for businesses in Nighoje MIDC. We ensure timely employee commutes and smooth transport operations."
  },
  {
    "WhyChooseheading": "Comprehensive Fleet for Industrial Transport Needs",
    "WhyChoosedescription": "Our fleet includes a variety of vehicles such as sedans, SUVs, and large capacity buses to accommodate the diverse transportation requirements of industrial employees."
  },
  {
    "WhyChooseheading": "Shift-Based Scheduling for Seamless Commutes",
    "WhyChoosedescription": "We offer transportation services aligned with factory and office shifts, ensuring employees are picked up and dropped off efficiently during all operational hours."
  },
  {
    "WhyChooseheading": "Professional Drivers Experienced in MIDC Routes",
    "WhyChoosedescription": "Our drivers are trained and familiar with the Nighoje MIDC area, guaranteeing safe and punctual travel for your workforce."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Security",
    "WhyChoosedescription": "All vehicles are GPS-enabled to provide real-time tracking, allowing companies full visibility and control over their employee transportation."
  },
  {
    "WhyChooseheading": "Transparent and Detailed Monthly Billing",
    "WhyChoosedescription": "We provide clear and itemized monthly invoices to help businesses manage transportation costs with complete transparency."
  },
  {
    "WhyChooseheading": "Adherence to Safety and Hygiene Standards",
    "WhyChoosedescription": "Vehicles are regularly sanitized and maintained to ensure a safe and hygienic environment for passengers throughout their commute."
  },
  {
    "WhyChooseheading": "Dedicated Support and Account Management",
    "WhyChoosedescription": "Our dedicated account managers oversee your transportation plans, assisting with scheduling and ensuring smooth day-to-day operations."
  }
]















}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services cover?",
      answer: "We provide corporate transportation services across Pune and nearby industrial zones, including Nighoje MIDC, Chakan, Ranjangaon, and surrounding areas."
    },
    {
      question: "Can we customize the transport plan to fit our company’s shifts and employee count?",
      answer: "Yes, we offer flexible transportation packages tailored to your workforce size, shift timings, and preferred routes."
    },
    {
      question: "Do you provide GST-compliant invoices for corporate billing?",
      answer: "Absolutely. Our monthly transport plans come with consolidated billing, GST-compliant invoices, and detailed usage reports."
    },
    {
      question: "Are professional drivers included in your services?",
      answer: "Yes, all drivers are trained, verified, and experienced in handling corporate transportation with safety and professionalism."
    },
    {
      question: "What safety measures are implemented for employee transport?",
      answer: "Our fleet is GPS-enabled, sanitized regularly, and undergoes routine maintenance. Driver verification and safety protocols are strictly followed."
    },
    {
      question: "Is dedicated support available for managing daily transportation operations?",
      answer: "Yes, we provide dedicated coordinators and live tracking tools to ensure smooth transport management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ramesh Kulkarni",
    designation: "Operations Head, Nighoje Manufacturing Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s services in Nighoje MIDC have significantly improved our employee commute experience—reliable, safe, and professional.”"
  },
  {
    name: "Ms. Deepa Shinde",
    designation: "HR Manager, TechnoFab Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“The corporate cab and bus service by eTravo in Nighoje MIDC is punctual and well-managed, making transport hassle-free for our staff.”"
  }
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Nighoje MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-nighoje.jpg",
  "description": "Book corporate cab and bus services in Nighoje MIDC with eTravo for employee transportation, office shuttle, and business event transport. Affordable and reliable AC cabs and buses tailored for companies in Nighoje Industrial Area.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-nighoje-midc"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Nighoje MIDC | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Nighoje MIDC with eTravo for office shuttle, employee transport, and business events. Reliable and budget-friendly AC cabs and buses for companies in Nighoje Industrial Area." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/100.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinnighole;